/**
 * Collection filters — "Pills" horizontal style.
 *
 * Loaded by sections/main-collection.liquid only when the section is set to
 * filter_type 'horizontal' + horizontal_filter_style 'pills'.
 *
 * Sole job: hide the selected-values count on a dropdown trigger while that
 * filter has nothing selected. The theme's <xo-filters-active-size> copies its
 * text from each filter response but skips empty text, so the count has to
 * render "(0)" rather than blank — this toggles a data-zero attribute that the
 * stylesheet hides. Liquid sets the attribute for the first paint; from then on
 * the element's text is rewritten by the theme and this keeps up with it.
 */
(function () {
  var SELECTOR =
    '.xo-facets-pills xo-filters-active-size[xo-unique-id$="-trigger"]';

  function syncCount(el) {
    var digits = (el.textContent || '').replace(/\D/g, '');
    var isZero = digits === '' || digits === '0';

    // Guard the write: this runs from a MutationObserver on the same element.
    if (isZero === el.hasAttribute('data-zero')) return;

    if (isZero) {
      el.setAttribute('data-zero', '');
    } else {
      el.removeAttribute('data-zero');
    }
  }

  function init() {
    var countEls = document.querySelectorAll(SELECTOR);
    if (!countEls.length) return;

    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var node = records[i].target;
        var el = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
        if (el) syncCount(el);
      }
    });

    for (var i = 0; i < countEls.length; i++) {
      syncCount(countEls[i]);
      // Text only — attribute changes are ours and must not re-trigger this.
      observer.observe(countEls[i], {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
